import './blog.js'
import './home.js'
import './pages.js'
import './experiments.js'
import './projects.js'
import './posts.js'
import './cv.js'
import './search.js'
import {open} from '../router.js'
open(location.href)
